import React from "react";
import { inject, observer } from "mobx-react";
import { Card, CardBody } from "reactstrap";
import styled from "styled-components";
import {
  BestLabel,
  BestSelect,
  Checkbox,
  DesktopTabletView,
  Icon,
  Input,
  MobileView,
  RequiredInput
} from "best-common-react";

const AddAll = styled.button`
  text-decoration: none !important;
`;

const AddOnCard = styled(Card).attrs({
  className: "mb-2"
})`
  &&& {
    border: 1px solid ${props => props.theme["grey"]};
    background-color: ${props => props.theme["light-grey"]};
    border-radius: 0;
  }
`;

const DeleteIcon = styled(Icon)`
  top: -10px;
  right: -10px;
`;

function createHomeAwayTypes(hats) {
  return hats.map(hat => {
    return {
      label: hat.homeAwayType.homeAwayTypeName,
      value: hat.homeAwayType.homeAwayTypeId,
      homeAwayType: hat.homeAwayType
    };
  });
}

function createFamilyDepartmentValue(departments) {
  return departments
    .filter(d => !d.isDeleted && d.relation === "family")
    .map(d => {
      return {
        label: d.departmentType.departmentName,
        value: d.departmentType.departmentTypeId,
        departmentName: d.departmentType.departmentName,
        relation: d.relation,
        departmentType: d.departmentType,
        isDeleted: d.isDeleted
      };
    });
}

function createFriendDepartmentValue(departments) {
  return departments
    .filter(d => !d.isDeleted && d.relation === "friends")
    .map(d => {
      return {
        label: d.departmentType.departmentName,
        value: d.departmentType.departmentTypeId,
        departmentName: d.departmentType.departmentName,
        relation: d.relation,
        departmentType: d.departmentType,
        isDeleted: d.isDeleted
      };
    });
}
function AddOn(props) {
  const addOn = props.addOn;

  let currentFriendDepartments = createFriendDepartmentValue(addOn.departments);
  let currentFamilyDepartments = createFamilyDepartmentValue(addOn.departments);

  let currentHomeAwayTypes = createHomeAwayTypes(addOn.homeAwayTypes);

  return (
    <AddOnCard>
      <CardBody>
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-end">
              <DeleteIcon
                id="delete-icon"
                iconName="fa-trash-alt"
                className="d-inline-block position-relative"
                onClick={() => {
                  addOn.deleted = true;
                }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-4 col-lg-12">
            <div className="row">
              <div className="col-xl-12 col-lg-6 col-md-12">
                <div className="row form-group">
                  <div className="col-sm-3 col-form-label text-nowrap py-0">
                    <BestLabel required={true}>Active</BestLabel>
                  </div>
                  <div className="col-sm-9">
                    <RequiredInput>
                      <Checkbox
                        id="add-on-name"
                        name="addOnNameActive"
                        onChange={event => {
                          addOn.active = !addOn.active;
                        }}
                        checked={addOn.active}
                      />
                    </RequiredInput>
                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-6 col-md-12">
                <div className="row form-group">
                  <div className="col-sm-3 col-form-label text-nowrap py-0">
                    <BestLabel required={true}>Name</BestLabel>
                  </div>
                  <div className="col-sm-9">
                    <RequiredInput>
                      <Input
                        id="add-on-name"
                        name="addOnName"
                        onChange={event => {
                          addOn.addOnName = event.target.value;
                        }}
                        value={addOn.addOnName}
                      />
                    </RequiredInput>
                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-6 col-md-12">
                <div className="row form-group">
                  <div className="col-sm-3 col-form-label text-nowrap py-0">
                    <BestLabel required={true}>Description</BestLabel>
                  </div>
                  <div className="col-sm-9">
                    <RequiredInput>
                      <Input
                        id="add-on-description"
                        name="addOnDescription"
                        onChange={event => {
                          addOn.addOnDescription = event.target.value;
                        }}
                        value={addOn.addOnDescription}
                      />
                    </RequiredInput>
                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-6 col-md-12">
                <div className="row form-group">
                  <div className="col-sm-3 col-form-label text-nowrap py-0">
                    <BestLabel required={true}>Quantity</BestLabel>
                  </div>
                  <div className="col-sm-9">
                    <Input
                      id="add-on-quantity"
                      name="addOnQuantity"
                      onChange={event => {
                        addOn.addOnQuantity = event.target.value;
                      }}
                      value={addOn.addOnQuantity}
                    />
                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-6 col-md-12">
                <div className="row form-group">
                  <div className="col-sm-3 col-form-label text-nowrap py-0">
                    <BestLabel required={false}>Price</BestLabel>
                  </div>
                  <div className="col-sm-9">
                    <Input
                      id="add-on-price"
                      name="addOnPrice"
                      onChange={event => {
                        addOn.addOnPrice = event.target.value;
                      }}
                      value={addOn.addOnPrice}
                    />
                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-6 col-md-12">
                <div className="row form-group">
                  <div className="col-sm-3 col-form-label text-nowrap py-0">
                    <BestLabel required={true}>Type</BestLabel>
                  </div>
                  <div className="col-sm-9">
                    <RequiredInput>
                      <BestSelect
                        id="home-away"
                        isMulti
                        options={props.homeAwayOptions}
                        values={currentHomeAwayTypes}
                        onChange={value => {
                          addOn.homeAwayTypes = value;
                        }}
                      />
                    </RequiredInput>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 col-md-12">
            <div className="d-flex align-items-center justify-content-between">
              <BestLabel required={true}>Family Ticket Allocation</BestLabel>
              <DesktopTabletView>
                <AddAll
                  id="add-all"
                  className="btn btn-link btn-sm pr-0"
                  onClick={() => {
                    let results = props.departmentOptions.map((v, index) => {
                      return {
                        isDeleted: false,
                        sequence: index,
                        departmentType: v.departmentType,
                        departmentSectionId: null,
                        relation: "family"
                      };
                    });
                    addOn.departments = results.concat(createFriendDepartmentValue(addOn.departments));
                  }}
                >
                  Add All Departments
                </AddAll>
              </DesktopTabletView>
              <MobileView>
                <div className="d-flex justify-content-end">
                  <AddAll
                    id="add-all"
                    className="btn btn-link btn-sm  pr-0 justify-content-end"
                    onClick={() => {
                      let results = props.departmentOptions.map((v, index) => {
                        return {
                          isDeleted: false,
                          sequence: index,
                          departmentType: v.departmentType,
                          departmentSectionId: null,
                          relation: "family"
                        };
                      });
                      addOn.departments = results.concat(createFriendDepartmentValue(addOn.departments));
                    }}
                  >
                    Add All Departments
                  </AddAll>
                </div>
              </MobileView>
            </div>
            <BestSelect
              isMulti
              id="family-departments"
              options={props.departmentOptions}
              defaultValue={[]}
              value={currentFamilyDepartments}
              className="basic-multi-select mb-3 mb-lg-0"
              classNamePrefix="select"
              onChange={value => {
                let results = value.map((v, index) => {
                  return {
                    isDeleted: false,
                    sequence: index,
                    departmentType: v.departmentType,
                    departmentSectionId: null,
                    relation: "family"
                  };
                });
                addOn.departments = createFriendDepartmentValue(addOn.departments).concat(results);
              }}
            />
          </div>
          <div className="col-xl-4 col-lg-6 col-md-12">
            <div className="d-flex align-items-center justify-content-between">
              <BestLabel required={true}>Friend Ticket Allocation</BestLabel>
              <DesktopTabletView>
                <AddAll
                  className="btn btn-link btn-sm pr-0"
                  onClick={() => {
                    let results = props.departmentOptions.map((v, index) => {
                      return {
                        isDeleted: false,
                        sequence: index,
                        departmentType: v.departmentType,
                        departmentSectionId: null,
                        relation: "friends"
                      };
                    });
                    addOn.departments = results.concat(createFamilyDepartmentValue(addOn.departments));
                  }}
                >
                  Add All Departments
                </AddAll>
              </DesktopTabletView>
              <MobileView>
                f
                <div className="d-flex justify-content-end">
                  <AddAll
                    className="btn btn-link btn-sm  pr-0"
                    onClick={() => {
                      let results = props.departmentOptions.map((v, index) => {
                        return {
                          isDeleted: false,
                          sequence: index,
                          departmentType: v.departmentType,
                          departmentSectionId: null,
                          relation: "friends"
                        };
                      });
                      addOn.departments = results.concat(createFamilyDepartmentValue(addOn.departments));
                    }}
                  >
                    Add All Departments
                  </AddAll>
                </div>
              </MobileView>
            </div>
            <BestSelect
              isMulti
              id="friends-departments"
              options={props.departmentOptions}
              value={currentFriendDepartments}
              defaultValue={[]}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={value => {
                let results = value.map((v, index) => {
                  return {
                    isDeleted: false,
                    sequence: index,
                    departmentType: v.departmentType,
                    departmentSectionId: null,
                    relation: "friends"
                  };
                });
                addOn.departments = createFamilyDepartmentValue(addOn.departments).concat(results);
              }}
            />
          </div>
        </div>
      </CardBody>
    </AddOnCard>
  );
}

export default inject("rootStore")(observer(AddOn));
